import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=a22818e8&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a22818e8')) {
      api.createRecord('a22818e8', component.options)
    } else {
      api.reload('a22818e8', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=a22818e8&", function () {
      api.rerender('a22818e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contacts/list/Form.vue"
export default component.exports